// data/static-contents.ts
import { InfoContent } from '../services/content.service';
import content_thymian from './html-contents/thymian.json';
import content_basilikum from './html-contents/basilikum.json';
import content_oregano from './html-contents/oregano.json';
import content_estragon from './html-contents/estragon.json';
import content_schnittlauch from './html-contents/schnittlauch.json';
import content_rosmarin from './html-contents/rosmarin.json';
import content_petersilie from './html-contents/petersilie.json';
import content_majoran from './html-contents/majoran.json';
import content_lorbeer from './html-contents/lorbeer.json';
import content_salbei from './html-contents/salbei.json';
import content_liebstoeckel from './html-contents/liebstoeckel.json';
import content_dill from './html-contents/dill.json';
import content_zitronenmelisse from './html-contents/zitronenmelisse.json';
import content_baerlauch from './html-contents/baerlauch.json';
import content_kuemmel from './html-contents/kuemmel.json';
import content_minze from './html-contents/minze.json';
import content_koriander from './html-contents/koriander.json';

export const STATIC_CONTENTS: InfoContent[] = [
  content_thymian as InfoContent,
  content_basilikum as InfoContent,
  content_oregano as InfoContent,
  content_estragon as InfoContent,
  content_schnittlauch as InfoContent,
  content_rosmarin as InfoContent,
  content_petersilie as InfoContent,
  content_majoran as InfoContent,
  content_lorbeer as InfoContent,
  content_salbei as InfoContent,
  content_liebstoeckel as InfoContent,
  content_dill as InfoContent,
  content_zitronenmelisse as InfoContent,
  content_baerlauch as InfoContent,
  content_kuemmel as InfoContent,
  content_minze as InfoContent,
  content_koriander as InfoContent
];
